var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.loadingCurrentImage)?_c('Loading'):_c('TabViews',{attrs:{"vertical":false,"centered":false,"tabs":_vm.reactiveTabs}}),_c('SnackBar',{attrs:{"snackbar":_vm.imageNotification.success,"text":_vm.imageNotification.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }